import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { IS_DEV, STATIC_ROOT } from '../../../../constants';
import { APPLE_PAY } from '../../../../constants/paymentMethods';

import SvgComponent from '../../../SvgComponent';

import './ApplePayStyle.scss';

const ApplePay = ({ selectedMethod, handleMethodChange, i18n }) => {
    const [displayApplePay, setDisplayApplePay] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const canMakePayments =
                !IS_DEV && window.ApplePaySession && window.ApplePaySession.canMakePayments();
            setDisplayApplePay(canMakePayments);
        }
    }, []);

    return displayApplePay ? (
        <div id="apple-pay-container" onClick={() => handleMethodChange(APPLE_PAY)}>
            <div>
                <input
                    type="radio"
                    id="apple-pay"
                    name="choix"
                    value={APPLE_PAY}
                    checked={selectedMethod === APPLE_PAY}
                />
                <label>{i18n.PAYMENT_CHOICE.APPLE_PAY}</label>
            </div>
            <SvgComponent src={`${STATIC_ROOT}/payment/apple-pay.svg`} widht={43} height={27} />
        </div>
    ) : null;
};

ApplePay.propTypes = {
    selectedMethod: PropTypes.string,
    handleMethodChange: PropTypes.func
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON
    };
};

export default connect(mapStateToProps)(ApplePay);



// WEBPACK FOOTER //
// ./src/components/funnel/payment-selection-step/payment-choice/ApplePay.js